import firebase from "../firebase";
import Typesense from "typesense";

// Frontend Typesense client.
// The search-only key is no longer embedded in the bundle. It is fetched from the
// backend (getTypesenseSearchKey) after login, then used to build the client.
// The client is created once and cached for the session; a failed fetch is not
// cached, so a later call can retry.
//
// - getTypesenseClient(): returns the cached client (fetching it on first use).
// - initTypesenseClient(): pre-warms the client right after login (fire-and-forget).
// - resetTypesenseClient(): drops the cached client on logout so the next user
//   never reuses the previous user's client.
let cachedClient = null;

export function getTypesenseClient() {
  if (!cachedClient) {
    cachedClient = firebase
      .functions()
      .httpsCallable("getTypesenseSearchKey")()
      .then(
        ({ data }) =>
          new Typesense.Client({
            nodes: [{ host: data.host, port: "443", protocol: "https" }],
            apiKey: data.apiKey,
          })
      )
      .catch((err) => {
        // Don't cache a failed fetch, so a later call can retry.
        cachedClient = null;
        console.error(
          "[typesense] failed to get search key via getTypesenseSearchKey —",
          "code:", err && err.code,
          "message:", err && err.message
        );
        throw err;
      });
  }
  return cachedClient;
}

// Pre-warm the client right after login so the first search does not pay the
// key-fetch (and Cloud Functions cold-start) cost. Fire-and-forget: callers must
// not await this, and a failure here is only logged — getTypesenseClient() will
// retry on the next call.
export function initTypesenseClient() {
  getTypesenseClient().catch(() => {});
}

// Drop the cached client, e.g. on logout, so the next user builds a fresh one.
export function resetTypesenseClient() {
  cachedClient = null;
}
